// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import Select from 'react-select';
import Modal from './Modal';
import Checkbox from '../Checkbox';

import '../../styles/modal.css';

export default class SharingSettings extends Modal {

    state = {
        access: false
    }

    componentDidMount = async () => {
        const stack = this.props.stack;
        this.setState({
            access: stack.restrict && stack.access && stack.access.length > 0
        });
    }

    componentWillReceiveProps = async (next) => {
        if (next.stack.access === this.props.stack.access)
            return;
        
        const stack = next.stack;
        this.setState({
            access: stack.restrict && stack.access && stack.access.length > 0
        });
    }

    renderContent = () => {
        
        const stack = this.props.stack && this.props.stack._id ? this.props.stack : {
            path: "",
            restrict: false,
            access: []
        };

        const team = this.props.team ? this.props.team : { _id: null, users: [] };
        
        return (<div className="modal-content modal-center">
            
            <br /><br /><br />

            <h1>Advanced Sharing Settings</h1>

            Who should have access to view and modify documents within the <strong>{stack.path}</strong> stack?

            <h2>Select an access control policy</h2>

            <div style={{
                width: 368,
                margin: "0 auto",
                textAlign: "left"
            }}>
                <Checkbox
                    label="Everyone on the team should have access"
                    checked={!stack.restrict}
                    onToggle={() => this.props.updateStack(stack._id, {
                        restrict: false
                    })}
                />
                <Checkbox
                    label="Only team administrators should have access"
                    checked={stack.restrict && stack.access && stack.access.length === 0 && !this.state.access}
                    onToggle={() => {
                        this.props.updateStack(stack._id, {
                            restrict: true,
                            access: []
                        });
                        this.setState({ access: false });
                    }}    
                />
                <Checkbox
                    label="Admins and certain users* should have access"
                    checked={stack.restrict && ((stack.access && stack.access.length > 0) || this.state.access)}
                    onToggle={() => {
                        this.props.updateStack(stack._id, {
                            restrict: true
                        });
                        this.setState({ access: true });
                    }}
                />

                {this.state.access ? <Select
                    components={{ DropdownIndicator: null }}
                    className="multi-select-container"
                    classNamePrefix="multi-select"
                    placeholder="Search users..."
                    isMulti
                    options={team.users.filter(user => !user.isAdmin).map(user => ({
                        value: user._id,
                        label: user.name
                    }))}
                    defaultMenuIsOpen={false}
                    value={stack.access.filter(userId => team.users.find(u => u._id === userId)).map(userId => ({
                        value: userId,
                        label: team.users.find(u => u._id === userId).name
                    }))}
                    onChange={users => this.props.updateStack(stack._id, {
                        restrict: true,
                        access: users ? users.map(u => u.value) : []
                    })}
                /> : <div className="modal-hint-after-checkbox">*Choose this option to select users</div>}

            </div>

        </div>);
    }

};